import styled from 'styled-components'

const AbilityBoxStyled = styled.div`
  .ability-box-container {
    clip-path: polygon(24px 0, 100% 0, 100% 100%, 0 100%, 0 24px);
    background: ${({ theme }) => theme.color.gradientDarkGreen};
    padding: 1px;

    .ability-box {
      clip-path: polygon(24px 0, 100% 0, 100% 100%, 0 100%, 0 24px);
      background: ${({ theme }) => theme.color.neutral};
      padding: 15px 15px 15px 25px;

      .title {
        font-size: 20px;
        line-height: 19px;
      }

      .level {
      }
    }
    .push-doping{
      background: transparent;
      border: none;
      img{
        width: 47px;
        margin-left: 10px;
      }
    }
  }

  .bottom-frame {
    bottom: -10px;
    right: 0;
    width: 100%;
    height: 18px;
  }

  .img__ability {
    width: 40px;
    height: 40px;
    cursor: pointer;
  }
`

export default AbilityBoxStyled
